<template>
    <div class="news-list">
        <div class="news-list__top">
            <div class="news-list__top-title">
                Новости проектов
            </div>
        </div>

        <div class="news-list__content">
            <div class="news-list__content-tabs">
                <STTabs :list="tabs"
                        @click="changeTab" />
            </div>

            <div
                class="news-list__content-wrapper"
                :style="{ opacity: animationOpacity, display: animationDisplay}">
                <div
                    v-for="tab in tabs"
                    v-show="activeTab === tab.id"
                    :key="tab.id"
                    class="news-list__content-item">
                    <NewsCard
                        v-for="article in showedItems"
                        :key="article.id"
                        :date="article.date"
                        :title="article.title"
                        :tag="article.tag"
                        :link="article.link" />
                </div>
            </div>

            <STBaseButton
                v-if="showedItems.length < activeArticles.length"
                text="Показать ещё"
                modify="button_theme_white news-list__content-more"
                :style="{ opacity: animationOpacity, display: animationDisplay}"
                @click="showMore" />
        </div>
    </div>
</template>

<script>
import NewsCard from '@/blocks/NewsCard/NewsCard';

export default {
    name: 'News',

    components: {
        NewsCard
    },

    props: {
        tabs: {
            type   : Array,
            default: () => ['empty']
        },
        articles: {
            type   : Array,
            default: () => []
        },
    },

    data() {
        return {
            activeTab       : null,
            showedItems     : [],
            page            : 1,
            maxArticles     : 9,
            activeArticles  : [],
            animationOpacity: '1',
            animationDisplay: 'block',
        };
    },

    watch: {
        tabs() {
            this.setActiveTab();
        },

        activeTab() {
            this.startAnimationFade();

            this.setActiveArticles();
        }
    },

    methods: {
        setActiveTab() {
            this.activeTab = this.tabs[0].id;
        },

        setActiveArticles() {
            if (this.activeTab == null) {
                return;
            }

            this.page = 1;

            this.activeArticles = [];
            
            this.activeArticles = this.activeTab === 'all' ?
                this.articles :
                this.articles.filter(item => item.category.includes(this.activeTab));

            this.showedItems = this.activeArticles.length < this.maxArticles ?
                this.activeArticles :
                this.activeArticles.slice(0, this.maxArticles);
        },

        changeTab(id) {
            this.activeTab = id;
        },

        showMore() {
            this.page++;
            this.showedItems = this.activeArticles.slice(0, this.maxArticles * this.page);
        },

        /* ANIMATIONS */
        startAnimationFade() {
            this.animationDisplay = 'none';
            this.animationOpacity = '0';

            setTimeout(() => {
                this.animationDisplay = 'block';
            }, 50);

            setTimeout(() => {
                this.animationOpacity = '1';
            }, 150);
        }
    }
};
</script>

<style lang="scss">
@import "NewsSection";
</style>
